import React from 'react';
import { popupOpenService } from '../../../services/popupOpenService';
import { useTranslation } from 'react-i18next';

const UpdateSeveralPropertiesActionsList = ({propertyId}) => {
    const { i18n } = useTranslation();
    const openUpdateSeveralPropertiesPopup = (key) => {
        popupOpenService.callToOpen(key, propertyId);
    };

    return (
        <ul className="property__update-dropdown">
            <li className="property__update-item" onClick={() => openUpdateSeveralPropertiesPopup('apply-to')}>
                {i18n.t('app.page.product.applyTo')}
            </li>
            <li className="property__update-item">
                {i18n.t('app.page.product.fillAs')}
            </li>
        </ul>
    );
};

export default UpdateSeveralPropertiesActionsList;
